import appConst from '../Utilities/appConst.json';
import { footerActions } from '../store/footerSlice';

export const disableButton = (dispatch) => {
    dispatch(footerActions.setBackground(appConst.LUPA_DISABLE_BACKGROUND_COLOR));
    dispatch(footerActions.setColor(appConst.LUPA_DISABLE_FONT_COLOR));
};

export const enableButton = (dispatch) => {
    dispatch(footerActions.setBackground(appConst.LUPA_GREEN_COLOR));
    dispatch(footerActions.setColor(appConst.LUPA_ENABLE_FONT_COLOR));
};